import { TechnicalParameters } from "@imi-ernd-be/hyselect-engine";
import {
  GetUsersPreferencesWaterCharacteristicsStatus200,
  TechnicalSettings,
} from "@imi/api-client/index.js";
import { assert } from "radashi";
import { technicalSettingsRepository } from "./technicalSettings/technicalSettingsRepository";
import { waterCharacteristicsRepository } from "./waterCharacteristics/waterCharacteristicsRepository";

export const technicalParametersRepository = {
  init(
    technicalParameters: TechnicalParameters,
    technicalSettings: Partial<TechnicalSettings> | null,
    waterCharacteristics: GetUsersPreferencesWaterCharacteristicsStatus200 | null,
  ) {
    const generalParameters = technicalParameters.getGeneralParams();
    assert(
      generalParameters,
      "generalParameters is null in technicalParametersRepository.init",
    );
    technicalSettingsRepository.init(generalParameters, technicalSettings);
    technicalParameters.setGeneralParams(generalParameters);

    const waterCharacteristicsParams =
      technicalParameters.getWaterCharacteristicsParams();
    assert(
      waterCharacteristicsParams,
      "waterCharacteristics is null in technicalParametersRepository.init",
    );
    if (waterCharacteristics) {
      waterCharacteristicsRepository.init(
        waterCharacteristicsParams,
        waterCharacteristics,
      );
    }
    technicalParameters.setWaterCharacteristicsParams(
      waterCharacteristicsParams,
    );

    return technicalParameters;
  },
};
